import React, {useEffect, useState, useMemo} from "react";
import {Checkbox, FormGroup} from "react-bootstrap";
import {removeDuplicates} from "../../../../../../platform/src/helpers/remove-duplicates";
import {getEventMembers} from "../../../../../../api/cp";

const WidgetSettingRoles = ({eventKey, widgetRoles, onChange}) => {
    const [selectedRoles, setSelectedRoles]  = useState([]);
    const [members, setMembers] = useState([]);

    useEffect(fetchEventMembers, []);

    useEffect(() => {
        setSelectedRoles(widgetRoles);
    }, [widgetRoles]);

    const rolesList = useMemo(() => {
        return removeDuplicates(members
            .map(({roles}) => roles)
            .flat(),
            'id'
        );
    }, [members]);

    async function fetchEventMembers() {
        try {
            const response = await getEventMembers(eventKey);
            response && setMembers(response);
        } catch (error) {
            console.error(error)
        }
    }

    const handleCheck = (key, value) => {
        const list = value
            ? [...selectedRoles, key]
            : selectedRoles?.filter((roleId) => roleId !== key)
        ;

        setSelectedRoles(list);
        onChange({roles: list});
    };

    return (
        <>
            {!!rolesList.length && (
                <FormGroup>
                    <p>Отображать дополнительный признак:</p>
                    <FormGroup
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '10px 20px',
                        }}
                    >
                        {rolesList.map((role) => (
                            <Checkbox
                                key={role.id}
                                style={{ margin: 0 }}
                                checked={selectedRoles?.includes(role.id)}
                                onChange={(e) => handleCheck(role.id, e.target.checked)}
                            >
                                {role.titleRu || role.titleEn}
                            </Checkbox>
                        ))}
                    </FormGroup>
                </FormGroup>
            )}
        </>
    );
};

export default WidgetSettingRoles;
